import { useList } from '@refinedev/core';
import { PricingTiersSection } from '@/components/pricing-tiers';
import type { TranslationLanguage } from '@/components/translations';

interface LanguageRecord {
  code: string;
  name: string;
  nativeName: string;
  flag?: string | null;
  flagEmoji?: string | null;
}

interface BookPricingTabProps {
  bookId: string | number;
}

export function BookPricingTab({ bookId }: BookPricingTabProps) {
  const { result: langResult } = useList<LanguageRecord>({ resource: 'languages' });
  const languages: TranslationLanguage[] = (langResult?.data ?? []).map((l) => ({
    code: l.code,
    name: l.name,
    nativeName: l.nativeName,
    flag: l.flag ?? l.flagEmoji ?? '🏳️',
  }));

  return (
    <div className="space-y-4">
      <PricingTiersSection
        productKey={{ bookId: Number(bookId) }}
        languages={languages}
      />
    </div>
  );
}
